/* eslint-disable node/no-unsupported-features/es-syntax */
import { EMPLOYEE_ROUTE_NAMES } from "@/shared";
export const EMPLOYEE_ROUTES = [
    {
        name: EMPLOYEE_ROUTE_NAMES.LIST,
        path: "/employee",
        meta: {
            title: "menu.employees",
        },
        component: () => import("../ui/EmployeesPage.vue"),
    },
    {
        name: EMPLOYEE_ROUTE_NAMES.PROFILE,
        path: "/employee/:employeeId",
        meta: {
            title: "menu.employee_profile",
        },
        component: () => import("../ui/EmployeeProfile.vue"),
        props: true,
    },
    {
        name: EMPLOYEE_ROUTE_NAMES.CREATE,
        path: "/employee/create",
        meta: {
            title: "menu.add_employee",
        },
        component: () => import("../ui/EmployeeEdit.vue"),
    },
    {
        name: EMPLOYEE_ROUTE_NAMES.EDIT,
        path: "/employee/edit/:employeeId",
        meta: {
            title: "menu.edit_employee",
        },
        component: () => import("../ui/EmployeeEdit.vue"),
        props: true,
    },
];
